import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { CLIENT_SIDE_KYC_AUTOMATIC } from "../shared/config";
import NieEuAdditionalData from "../../shared/NieEuAdditionalData/NieEuAdditionalData";
import { fakeFormsDataKYCAutomatic } from "../../../../../utils/fakeFormsData";
import BackButton from "../../../../shared/components/BackButton";
import { STEP_GROUP_IDS } from "../../../../shared/config";
import { useStepHandler } from "../../../../../utils/hooks/useStepHandler";
import { useKycAutomatic } from "../shared/hooks/useKycAutomatic";
import KycElectronicID from "../shared/steps/KycElectronicId";
import RetryElectronicId from "../shared/components/RetryElectronicId";
import LenderSpecificOptIns from "../../../signature/Signature/components/LenderSpecificOptIns";

export const KycAutomaticWithNieEu = (props) => {
  const { disableMaritalRegime, disableKycManual } = props;

  const [optInsState, setOptInsState] = useState({
    omitted: false,
    completed: false,
  });

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: CLIENT_SIDE_KYC_AUTOMATIC.NIE_EU_ADDITIONAL_DATA,
      show: () => nieEu,
      isGroup: true,
    },
  ];

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.ClientSideSignatureKycAutomatic;

  const {
    electronicIDPassed,
    nieEu,
    onSubmitModule,
    onKoStep,
    onElectronicIDOk,
    participant,
    onRetryElectronicId,
  } = useKycAutomatic({ disableMaritalRegime });

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsDataKYCAutomatic
  );

  const { manageGroup, submitStep, onBack, backButtonVisible } =
    currentModuleStepHandler;

  useEffect(() => {
    if (electronicIDPassed) {
      if (!nieEu) {
        onSubmitModule();
      } else {
        manageGroup(CURRENT_STEP_GROUP, STEP_GROUP_STEPS_ARRAY);
      }
    }
  }, [electronicIDPassed]);

  const onOptInsOmit = () => {
    setOptInsState((s) => ({ ...s, omitted: true }));
  };

  const onOptInsSuccess = () => {
    setOptInsState((s) => ({ ...s, completed: true }));
  };

  const lenderSpecificOptInsResolved =
    optInsState.omitted || optInsState.completed;

  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton onBack={onBack} show={backButtonVisible} />
      </Box>
      {!electronicIDPassed && lenderSpecificOptInsResolved ? (
        <KycElectronicID
          submitStep={submitStep}
          onSubmitForm={onElectronicIDOk}
          onKoStep={onKoStep}
          disableKycManual={disableKycManual}
        />
      ) : (
        <LenderSpecificOptIns
          onOmit={onOptInsOmit}
          onSuccess={onOptInsSuccess}
        />
      )}
      {electronicIDPassed && nieEu && (
        <NieEuAdditionalData
          participant={participant}
          currentModuleStepHandler={currentModuleStepHandler}
        />
      )}
      <RetryElectronicId onRetryElectronicId={onRetryElectronicId} />
    </>
  );
};
